import(/* webpackMode: "eager" */ "C:\\Users\\Pedro polo\\Documents\\Programacion\\aquiapp-main\\src\\app\\not-found.tsx");
